<template>
    <div class="j-map-coordinate-wrap" :style="{ left: `${point.left + 12 || 0}px`, top: `${point.top - 42 || 0}px` }" >
        <table>
            <tr>
                <td>经度</td>
                <td>{{point.longitude}}</td>
            </tr>
            <tr>
                <td>纬度</td>
                <td>{{point.latitude}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
  name: 'JMapCoord',
  props: {
    point: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped lang="scss">
    .j-map-coordinate-wrap {
        position: absolute;
        padding: 5px;
        box-sizing: border-box;
        background-color: rgba(255,255,255, .7);
        font-size: 12px;
        border-radius: 3px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        z-index: 99;
        &::before {
            content: '';
            position: absolute;
            top: 19px;
            left: -24px;
            height: 24px;
            width: 24px;
            background-size: contain;
            background-repeat: no-repeat;
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAB+ElEQVRYR+2VP2jUUBzHv7+rIJicOrkoOBW3urmISpJiRVqRDgURXMRBxBdR6mQnndTBS0UcOtRFBKkdDkGEe4cODg7WVdyqOIpwSVG45iuBuyJy+fNyGZMx+X2/75Pv+73fExg8wVfu5ma00GhgisQUgKMQxEJsxOSGyMQn5e55ZWAJKVrcevd7UuL+ExDTmRrBav/P9q2bZ/b9LOJdCOBxN5qNyXYRw2ENgWnftTt5mlyAQIeXADzLMxr1XUSuXnesp1naTICgu3UIjL+VWXwnCcbHfW/vhzSPbAAdvgEwMw6AAJ8bsnXimnMgHJlSmvlyNzpPcn2cxf/ph4u+az83Agg6vTsQuVsFAIT3lNNcMgPQvTVA5qsBkLZyrHNGAC0dfhfgYCUAkB/KtUZ6pTZhxQCbyrUOGyUQVLgFJF/4XvOCGUCFTUhi0ffsh0YAVR5DsD+jvP1vjQCS4kCHySx3x2pEkZfKsRZKTcKWjs4K+HocgJg8dcNrvi8FkIhaOloR8HIZCJIrvte8UvoyGgoDHS4CuG8IcVu59oM8Te51vAPR+XUasisZzcdyTD+C/aW0pvtfWxhgKHzU6Z2caMgciTkARwbvv4igvR2znbXfxqcgL75Ah0xqlGsb/8jQu7RwcExrgDqBOoE6gTqB7mAUO3ljO+37X/vZ0yGYHXAQAAAAAElFTkSuQmCC");
        }
        > table {
            background-color: #f8f8f8;
            border-collapse: collapse;
            border: 1px solid #dadada;
            color: #606266;
            tr, td {
                padding: 4px;
                border: 1px solid #dadada;
            }
        }
    }
</style>
